import { render, staticRenderFns } from "./AlipayAuth.vue?vue&type=template&id=9b6ff0be"
import script from "./AlipayAuth.vue?vue&type=script&lang=js"
export * from "./AlipayAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports